import { ActivityIndicator, Image, StyleSheet } from 'react-native';
import React, { useState } from 'react';
import { ThemedView, ThemedText, ThemedPressable, Theme } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { endpoints } from '@app/api/apis';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@app/store/hooks';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { getEnabledRTA } from '@app/screens/KYCStepper/services/service';
import { updateLinkedApplication } from '@app/store/slices/authSlice';
import { ThemedTouchableOpacity } from '@app/theme/Components';
import ElevateRate from "../../../../assets/Icons/ElevateRate";
import { useTheme } from '@shopify/restyle';
import { trackEvent } from '@app/utils';

export const bookTransferV2Api = async (payload: { accountId: string }) => {
  const response = await axios.get(endpoints.bookTransferV2 + 'allowed/' + payload.accountId);
  return response.data;
}

const ElevateContinueCard = ({ navigation , elevateDetails }: { navigation: any , elevateDetails: any}) => {


  const dispatch = useDispatch();
  const accountId = useAppSelector(state => state?.auth?.userDetails?.linkedApplications[0]?.accountId)

  const [isLoading, setIsLoading] = useState(false)

  const {colors} = useTheme<Theme>()





  const handleElevateContinue = async () => {
    setIsLoading(true)
    try {
      const response = await bookTransferV2Api({ accountId: accountId });
      trackEvent('ELEVATE_CONTINUE_CARD_CLICKED')
      const newDspApplicationId = response?.creditApplication?.applicationId
      if(newDspApplicationId) {
        await AsyncStorage.setItem('application_id', newDspApplicationId)
      }
      await AsyncStorage.setItem('isElevate', "true")
      AsyncStorage.setItem("newUserElevateData", JSON.stringify(elevateDetails?.creditApplication))
      const currentStepId = response?.creditApplication?.currentStepId
      dispatch(updateLinkedApplication(response?.creditApplication))
      if (
        currentStepId === 'MF_FETCH_PORTFOLIO' ||
        currentStepId === 'MF_PLEDGE_PORTFOLIO'
      ) {
        const enabledRTAFlowResponse = await getEnabledRTA({applicationId : newDspApplicationId})
        const isFromMFCentral =
          enabledRTAFlowResponse?.enabledRtaFlow === "MfCentralFlow"
        const mfcFetchStatus = enabledRTAFlowResponse?.mfcFetchStatus

        if (mfcFetchStatus === 'IN_PROGRESS') {
          navigation.navigate("MFC_FETCH_EVALUTE_FUNDS")
          return 
        } else if (
          isFromMFCentral &&
          currentStepId === "MF_PLEDGE_PORTFOLIO"
        ) {
          navigation.navigate("MFC_FETCH_ANCHOR")
          return
        } else if (
          isFromMFCentral &&
          currentStepId === "MF_FETCH_PORTFOLIO"
        ) {
          navigation.navigate("MF_FETCH_PORTFOLIO")
          return
        } else if (!isFromMFCentral) {
          const determinedStep = getNextRoute(currentStepId, response?.creditApplication?.applicationState, response?.creditApplication?.stepStatusMap)
          navigation.navigate(determinedStep)
        }
      } else {
        const determinedStep = getNextRoute(currentStepId, response?.creditApplication?.applicationState, response?.creditApplication?.stepStatusMap)
        navigation.navigate(determinedStep)
      }
    } catch (err: any) {
      dispatch(showErrorSheet({
        isErrorSheetVisible: true,
        errorMessage: err?.data?.message,
        closeOnBackdropPress: true,
        errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
        errorHeading: err?.data?.header,
        showErrorHeading: true,
        btnName: 'Ok, got it!',
      }))
    } finally {
      setIsLoading(false)
    }
  }
  return (
     <ThemedPressable onPress={handleElevateContinue} justifyContent='space-between' flexDirection='row' alignItems='center' borderRadius='lg' backgroundColor="bg-action-primary" overflow='hidden' mx="lg" mt="lg">
      <ThemedView pl="md" pb="2xl" pt="lg" flex={2}>
        <ThemedText textTransform='uppercase' variant='b4r' color="text-on-action-primary" mb="sm">Offer Ends Soon</ThemedText>
        <ThemedText variant='b3b' color="chalk">
          Get exclusive access to {'\n'}lowest rates
        </ThemedText>
        <ThemedTouchableOpacity flexDirection='row' onPress={handleElevateContinue}  bg='bg-fill-primary' borderRadius='full' alignSelf='flex-start' mt='lg' paddingVertical='xs' paddingHorizontal='lg'>
          <ThemedText mr={ isLoading ? 'md' : undefined} variant='b4b' color='text-action-primary'>Continue</ThemedText>
          {isLoading && (
          <ActivityIndicator size={12} color={colors['bg-action-primary']} />
          )}
        </ThemedTouchableOpacity>
      </ThemedView>
      <ThemedView flex={1.2}>
        <ElevateRate shadowColor={colors['border-emphasis-primary']} />
        <ThemedView alignItems='center' overflow='hidden' px='sm' py='xs' mr='md' borderRadius='full' mt='md'>
          <ThemedText color='text-on-action-primary' style={{zIndex: 10}} variant='b5b'>₹0 Processing fee</ThemedText>
          <ThemedView style={[StyleSheet.absoluteFillObject, {opacity: 0.1}]} bg='bg-surface-emphasis-primary' />
        </ThemedView>
      </ThemedView>
      <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_home_card_mesh.png" }} style={{ width: 120, height: 200, position: "absolute", right: 0 }} />
    </ThemedPressable>
  );
};

export default ElevateContinueCard;

